import { useParams } from 'react-router-dom'
import { CustomerUserList } from '../../components/customer/CustomerUserList'
import { UpdateCustomerUser } from '../../components/customer/UpdateCustomerUser'

export const CustomerUsersView = () => {
  const { id } = useParams()

  const isValidId = typeof id !== 'undefined' && !isNaN(+id)

  return (
    <>
      {isValidId && <UpdateCustomerUser />}
      {!isValidId && <CustomerUserList />}
    </>
  )
}
